import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-profitreport',
  templateUrl: './profitreport.component.html',
  styleUrls: ['./profitreport.component.scss']
})
export class ProfitreportComponent implements OnInit {

  From: string;
  To: string;

  public selectedStore: string = '';
  public stores: any[] = [];

  public SummaryReport_Row: any[] = [];
  public totalAmount: number = 0;

  constructor(public appservice: AppService, public datePipe: DatePipe) {

    this.From = this.datePipe.transform(new Date(), "yyyy-MM-dd")!;
    this.To = this.datePipe.transform(new Date(), "yyyy-MM-dd")!;

  }

  ngOnInit(): void {

  }

  get_profitReport() {

    this.appservice.get(`Api/transaction/get_ProfitReport?From=${this.From}&To=${this.To}&branch=1&status=P`)
      .subscribe((res: any) => {

        if (res && res !== '') {

          const parsed = typeof res === 'string' ? JSON.parse(res) : res;

          this.SummaryReport_Row = parsed.record || parsed || [];

          this.totalAmount = this.SummaryReport_Row.reduce((sum, row) => {
            const profit = parseFloat(row['Profit']) || 0;
            return sum + profit;
          }, 0);

          console.log("Records:", this.SummaryReport_Row);
          console.log("Total Profit:", this.totalAmount);

        }
        else {

          this.SummaryReport_Row = [];
          this.totalAmount = 0;
          alert("No Data Found");

        }

      });

  }

  display() {
    this.get_profitReport();
  }

  Back() {
    this.appservice.back();
  }

  export_excel() {

    this.appservice.Excel_Data.items = this.SummaryReport_Row;
    this.appservice.Excel_Data.Report_Name = "ProfitReport";
    this.appservice.Excel_Data.FileName = "ProfitReport";

    this.appservice.export_excel();

  }

}